import { render, staticRenderFns } from "./FilesPreviewTable.vue?vue&type=template&id=76adf6ba&scoped=true&"
import script from "./FilesPreviewTable.vue?vue&type=script&lang=js&"
export * from "./FilesPreviewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76adf6ba",
  null
  
)

export default component.exports